export default "__VITE_ASSET__$RLiolZ7__"